import { render, staticRenderFns } from "./Emergency_General.vue?vue&type=template&id=3d67583a&scoped=true"
import script from "./Emergency_General.vue?vue&type=script&lang=js"
export * from "./Emergency_General.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d67583a",
  null
  
)

export default component.exports